import { Navigate, NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, LogOut, Package, ShoppingCart, Truck, Upload, ExternalLink, Images, Ticket, LifeBuoy, Percent } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LogoMark } from "@/components/Logo";

const NAV = [
  ["/admin", "Dashboard", LayoutDashboard, true],
  ["/admin/prodotti", "Prodotti", Package],
  ["/admin/homepage", "Homepage e slide", Images],
  ["/admin/ordini", "Ordini, pagamenti, rimborsi", ShoppingCart],
  ["/admin/richieste", "Assistenza, resi, garanzie", LifeBuoy],
  ["/admin/coupon", "Coupon", Ticket],
  ["/admin/prezzi", "Prezzi (+4%)", Percent],
  ["/admin/spedizioni", "Spedizioni e impostazioni", Truck],
  ["/admin/importa", "Importa CSV Ecwid", Upload],
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  if (user === null) return <div className="min-h-screen bg-[#0A0B0E]" />;
  if (user === false) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-[#0A0B0E] text-white md:flex" data-testid="admin-layout">
      <aside className="border-b border-white/10 bg-[#0D0F13] md:sticky md:top-0 md:h-screen md:w-64 md:shrink-0 md:border-b-0 md:border-r">
        <div className="flex items-center gap-2 px-5 py-5"><LogoMark className="h-8 w-8" /><span className="font-display font-semibold tracking-[0.15em]">ADMIN</span></div>
        <nav className="no-scrollbar flex gap-1 overflow-x-auto px-3 pb-3 md:flex-col md:pb-0">
          {NAV.map(([to, label, Icon, end]) => (
            <NavLink key={to} to={to} end={end} data-testid={`admin-nav-${to.split("/").pop()}`}
              className={({ isActive }) => `flex shrink-0 items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors ${isActive ? "bg-[#0066FF]/15 text-white" : "text-slate-400 hover:bg-white/5 hover:text-white"}`}>
              <Icon className="h-4 w-4" />{label}
            </NavLink>
          ))}
          <a href="/" target="_blank" rel="noreferrer" className="flex shrink-0 items-center gap-3 rounded-lg px-3 py-2.5 text-sm text-slate-400 hover:text-white"><ExternalLink className="h-4 w-4" />Vedi negozio</a>
          <button onClick={logout} data-testid="admin-logout-btn" className="flex shrink-0 items-center gap-3 rounded-lg px-3 py-2.5 text-left text-sm text-slate-400 hover:text-red-400"><LogOut className="h-4 w-4" />Esci</button>
        </nav>
      </aside>
      <main className="min-w-0 flex-1 p-4 sm:p-8"><Outlet /></main>
    </div>
  );
}
